/**
 * Announcement entity class
 */

import moment from 'moment'

/**
 * AnnouncementFactory
 * returns Announcement entity class
 *
 * @class AnnouncementFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.Announcement} class
 *
 * @ngdoc factory
 * @name mwApp.factory:AnnouncementFactory
 */
/* @ngInject */
export default function AnnouncementFactory (Entity, m2mMixin, onOffMixin) {
  /* === Announcement class === */

  /**
   * Announcement model
   *
   * @class Announcement
   * @classdesc Announcement model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @mixes models.m2mMixin
   * @mixes models.onOffMixin
   * @return {models.Announcement} Announcement entity
   */
  function Announcement () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  Announcement.prototype = Object.create(Entity.prototype)
  Announcement.prototype.constructor = Announcement

  /* === Announcement instance methods & fields === */

  Object.assign(Announcement.prototype, {

    /**
     * instance fields
     *
     * @memberof models.Announcement#
     * @type {Object}
     */
    _fields: {
      id: Number,
      name: String,
      announcementType: String, // ANNOUNCEMENT_TYPE
      creationTime: moment,
      days: Number,
      enabled: true,
      message: String,
      networkId: Number,
      reminderType: String, // REMINDER_TYPE
      subscribers: ['Subscriber'],
      userName: String
    },

    /**
     * url template
     *
     * @memberof models.Announcement#
     * @type {String}
     */
    _urlTemplate: 'api/networks/{{::networkId}}/announcements/{{::id}}',

    /**
     * Get underlying object
     *
     * @memberof models.Announcement#
     * @return {Object} new underlying object as plain object
     * @override
     */
    _object: function () {
      var ret = Entity.prototype._object.apply(this, arguments)
      ret.subscribers = ret.subscribers.map(s => (s.id ? { id: s.id } : s))
      if (ret.platforms) {
        ret.platforms = ret.platforms.filter(p => p.checked)
        ret.platforms = ret.platforms.map(p => p.name)
      }
      if (ret.statusGroups) {
        ret.statusGroups = ret.statusGroups.filter(sg => sg.checked)
        ret.statusGroups = ret.statusGroups.map(sg => sg.name)
      }
      return ret
    }

  }, m2mMixin('subscribers'), onOffMixin)

  /* === Announcement static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(Announcement, Entity)
  Announcement._name = 'Announcement'
  Announcement._publicName = 'Reminder'
  Announcement.init()

  // permissions
  Announcement.access = {
    view: 'viewAnnouncement',
    create: 'createAnnouncement',
    edit: 'editAnnouncement',
    delete: 'deleteAnnouncement'
  }

  // extra
  Announcement.extra = {
    activationToaAnnouncement: 'Announcement',
    disabledAnnouncement: 'Announcement',
    pendingAnnouncement: 'Announcement',
    suspendedAnnouncement: 'Announcement',
    subscribers: ['Subscriber']
  }

  return Announcement
}
